import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'

const endpoint = `${apiUrl.stable}/favoritos`

/**
 * Add a company to the user's favorite list
 * @param {string} companyId
 */
export const getFavorite = (page = null, filter = null, serviceType = null) => {
  const url = `${endpoint}/obtem`

  const options = {
    Page: page,
    Filter: filter,
    ServiceTypeId: serviceType,
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: {
      ...jsonWebToken.header,
    }
  }

  return axios.get(url, axiosConfig)
}

/**
 * Add a company to the user's favorite list
 * @param {string} companyId
 */
export const addFavorite = (companyId) => {
  const url = `${endpoint}/adicionar`

  const axiosConfig = {
    headers: {
      ...jsonWebToken.header,
      'Content-Type': 'application/json;charset=utf-8'
    }
  }

  return axios.post(url, companyId.toString(), axiosConfig)
}

/**
 * Add a company to the user's favorite list
 * @param {string} companyId
 */
export const removeFavorite = (companyId) => {
  const url = `${endpoint}/remover`

  const axiosConfig = {
    headers: {
      ...jsonWebToken.header,
      'Content-Type': 'application/json;charset=utf-8'
    }
  }

  return axios.post(url, companyId.toString(), axiosConfig)
}

export default {
  addFavorite,
  removeFavorite,
}